export const SessionVisibility = {
  PUBLIC: "public",
  EARLY_ACCESS: "early_access",
  HIDDEN: "hidden"
};
